<template>
   <!--采购商指数-->
   <div class='providers_container'>
         <ul class='pop-titles'>
              <li>排名</li>
              <li>姓名/企业名称</li>
              <li>采购商浏览</li>
         </ul>
         <div id='popProvider' class='flow-cont'>
           <div id='slider' class='slider'>
            <ul ref='listCont'>
               <li class='list-item-rank' v-for="(item,index) in persons" :key="index">
                  <ul :class="['rank-item-cont',{'top3':index<3}]">
                     <li>{{item.rank}}</li>
                     <li>{{item.seller_name}}</li>
                     <li>{{item.pv}}</li>
                  </ul>
               </li>
            </ul>
          </div>
         </div>
   </div>
</template>
<script>
import { http } from '@/http'
export default{

  data () {
    return {
      persons: [],
      slider: null
    }
  },
  methods: {
    // 获取地图数据
    getData (cb) {
      http.get('/canmou/tianji/product/top_seller?product_id=8048&county_id=2215').then(res => {
        // 数据
        this.persons = res.data.data.items
        if (res.data.status === 0) {
          cb && cb()
        }
      })
    }
  },

  mounted () {
    // 获取数据
    this.getData(() => {
      this.$nextTick(() => {
        let slider = document.getElementById('slider')
        let itemHeight = 52
        let curIndex = 0
        let listCount = this.persons.length
        let moveCount = 6

        slider.appendChild(this.$refs['listCont'].cloneNode(true))
        setTimeout(slide, 5000)
        function slide () {
          if (curIndex >= listCount) {
            curIndex = -moveCount
            slider.style.transition = 'none'
          } else {
            // slider.style.transition='all 0.3s';
          }
          curIndex += moveCount
          slider.style.transform = 'translateY(' + (-curIndex * itemHeight) + 'px)'
          setTimeout(slide, 5000)
        }
      })
    })
  }
}

</script>
<style lang='less' scoped>
.slider{
  transform:translateY(0);
}
.top3{
  background:#0e203e;
  opacity:0.9;
  color:#0effff;
}
.rank-item-cont li{
  float :left;
  max-width:454px;
  overflow:hidden;
  text-overflow:ellipsis;
}
  ul,li{
   margin:0;
   padding:0;
   list-style:none;
  }
  .rank-item-cont{
    width:100%;
    height:40px;
    display:flex;
    justify-content:space-between;
    align-items:center;
    font-size:28px;
    color:#fff;
    padding:0 20px;
    margin-bottom:12px;
  }

  .flow-cont{
    height:358px;
    overflow:hidden;
  }
 .pop-titles li{
   float:left;
   font-size:30px;
   font-weight:bold;
   color:#fff;
   list-style:none;

 }
 .pop-titles{
   height:66px;
   width:100%;
   display:flex;
   justify-content:space-between;
   align-items:center;

 }

  .providers_container{
    padding: 0 25px;
    width: 100%;
    height:100%;
    background:none;
  }
</style>
